import { render, staticRenderFns } from "./AdultChildList.vue?vue&type=template&id=0289e791&"
import script from "./AdultChildList.vue?vue&type=script&lang=js&"
export * from "./AdultChildList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports